import React from 'react'

export default (props) =>
  <svg width='9' height='13' viewBox='0 0 9 13' fill='none'>
    <path d='M7.51074 11.3828L2.34053 6.49983L7.51074 1.61685' stroke='white' strokeWidth='2' />
  </svg>
